import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { bankDetailsValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";

const BankDetails = (props: any) => {
  const { user, bankData } = props;
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(bankDetailsValidationForm),
    defaultValues: async () => {
      return {
        ...bankData[0],
      };
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["bank-details"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.BANK_DETAIL}`;
    let formData = {
      object_id: user?.id,
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data: any) =>
        handleUpdateProfile(data, setError)
      )}
      autoComplete="off"
    >
      <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Name"}
          register={register("beneficiary")}
          errors={errors?.beneficiary}
        />
        <TextField
          label={"Account No."}
          register={register("account_number")}
          errors={errors?.account_number}
        />
        <TextField
          label={"Swift Code"}
          register={register("code")}
          errors={errors?.code}
        />
        <TextField
          label={"Bank Name"}
          register={register("bank_name")}
          errors={errors?.bank_name}
        />
        <TextField
          label={"Address"}
          register={register("address")}
          errors={errors?.address}
        />
      </div>
      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-[100px] mr-4`}>
          <Button label={"Update"} isLoading={isPostLoading} />
        </div>
      </div>
    </form>
  );
};

export default BankDetails;
